import React from 'react';

export const Loader = ({ label = 'Loading' }) => (
  <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3" data-testid="loader">
    <div className="h-8 w-8 animate-spin rounded-full border-2 border-[hsl(var(--primary))]/20 border-t-[hsl(var(--primary))]" />
    <p className="text-sm text-muted-foreground">{label}...</p>
  </div>
);

export const EmptyState = ({ icon: Icon, title, subtitle, action }) => (
  <div className="flex flex-col items-center justify-center gap-3 py-20 text-center">
    {Icon && <Icon className="h-10 w-10 text-muted-foreground" />}
    <h3 className="text-xl font-semibold">{title}</h3>
    {subtitle && <p className="max-w-md text-sm text-muted-foreground">{subtitle}</p>}
    {action}
  </div>
);

export default Loader;
